import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect, useDispatch } from 'react-redux';
import {
    deletePost,
    setCategoriesMode,
    setPostAction,
    setSelectedPost,
    setShowPostAlbum,
    setDarkmode,
    setPostMedias,
    setAlert
} from '../../../redux/actions';
import { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import AlertConfirmModal from '../AlertConfirmModal';
import copy from 'copy-to-clipboard';
import useDidMountEffect from '../../utils/useDidMountEffect';

const PostActions = ({
    post,
    comment,
    refetch,
    setPostAction,
    setRefetch,
    setSelectedPost,
    setCategoriesMode,
    setShowPostAlbum,
    activePost,
    action,
    isPu = true,
    deletePost,
    setAlert,
}) => {
    const dispatch = useDispatch();
    const perPage = 15;
    const { addToast } = useToasts();
    const [show, setShow] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [hasConfirm, setHasConfirm] = useState(false);
    const [isloading, setIsLoading] = useState(false);
    const [pinned, setPinned] = useState(post.pinned);
    const [categoryEditMode, setCategoryEditMode] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeCategory, setActiveCategory] = useState({});
    const [hasMore, setHasMore] = useState(false);
    const [medias, setMedias] = useState([]);

    const handleModal = () => setShowModal(!showModal);

    useEffect(() => {
        const callAlbumModal = () => {
            handleWallAlbums();
        };
        window.addEventListener(`post/${post.id}/callAlbum`, callAlbumModal);

        return () => window.removeEventListener(`post/${post.id}/callAlbum`, callAlbumModal);
    }, []);

    useEffect(() => {
        const onCategoryChanged = ({ detail }) => {
            if (categoryEditMode === true) {
                console.log(detail);
                setCurrentCategories(detail);
            }
        };

        const onHideCategoryModal = () => {
            // on cancel
            console.log("post.categories: ", post.categories);
            setTimeout(() => {
                setCurrentCategories(post.categories);
                setCategoryEditMode(false);
            }, 10);
        };

        const onConfirmCategoryModal = () => {
            setCategoryEditMode(false);
        };


        if (categoryEditMode === true) {
            window.addEventListener('wall-album/checkchange', onCategoryChanged);
            window.addEventListener('category-modal/hide', onHideCategoryModal);
            window.addEventListener('category-modal/confirm', onConfirmCategoryModal);
        } else {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        }

        return () => {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        };
    }, [categoryEditMode]);

    const handleWallAlbums = () => {
        setPostAction('add_to_album');
        window.dispatchEvent(new Event('footer/add-to-album/' + post.id));
        setSelectedPost(post);
        setShowPostAlbum(true);
        setCategoriesMode(1);
    };

    const handleEdit = () => {
        setPostAction('edit');
        setSelectedPost(post);
    };

    const handleDeleteConfirm = () => {
        setPostAction('delete');
        setAlertText('Are you sure you want to delete this post?');
        setShow(true);
        setHasConfirm(true);
    };

    const handleDelete = async () => {
        setIsLoading(true);
        await axios.delete(`/api/posts/${post.id}`)
            .then(response => {
                deletePost({ id: post.id });

                getMedias('onload');

                setIsLoading(false);
                if (!isloading) {
                    setSelectedPost([]);
                }
                setAlert({
                    show: true,
                    type: 'success',
                    body: 'Post successfully deleted'
                });
            })
            .catch(error => {
                console.log({ error });
                setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to delete post'
                });
                setIsLoading(false);
            });
    };

    const pathname = window.location.pathname.replace('/', '');
    const getMedias = async (source = 'onload') => {
        setIsLoading(true);
        await axios.get('/api/posts/medias', {
            params: {
                user: pathname ?? userInformation.login,
                page: source == 'onload' ? 1 : currentPage,
                per_page: perPage,
                is_pu: isPu,
                category_id: activeCategory && Object.keys(activeCategory).length > 0 ? activeCategory.id : '',
            }
        }).then(response => {
            setHasMore(response.data.data.length > 0);

            if (!refetch && source == 'onload') {
                dispatch(setPostMedias(response.data.data));
            } else {
                const mediaIds = new Set(medias.map(post => post.id));
                const merged = [...medias, ...response.data.data.filter(d => !mediaIds.has(d.id))];
                dispatch(setPostMedias(merged));
            }
            setRefetch(false);
        }).catch(error => {
            console.error({ error });
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const handlePin = () => {
        setPostAction('pin');
        setPinned(pinned => !pinned);
    };

    const handleUpdate = async () => {
        setIsLoading(true);
        // check item for home and profile page
        await axios.post(`/api/posts/${post.id}`, {
            pinned: pinned
        }).then(response => {
            // check if post is homepage
            if (window.location.pathname != '/home') {
                setRefetch(true);
            }
            addToast('Post updated', { appearance: 'success', autoDismiss: true });
        })
            .catch(error => {
                console.log({ error });
                addToast('Unable to update post', { appearance: 'error', autoDismiss: true });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useDidMountEffect(() => {
        handleUpdate();
    }, [pinned]);

    const handleCopy = () => {
        setPostAction('copy_link');
        const origin = window.location.origin;
        const pathname = window.location.pathname;
        const link = `${origin}/${post.user.login}?postid=${post.id}`;
        copy(`${link}`, {
            debug: false,
            message: 'Click to copy link',
        });
        setAlertText('Copied Post URL link: \n' + link);
        setShow(true);
        setHasConfirm(false);
    };

    return <>
        <AlertConfirmModal modalTitle="" modalBody={alertText} show={show} setShow={setShow} isConfirm={hasConfirm} useFunction={handleDelete} />
        <div className="posts-list-item-footer-dots">
            <Dropdown drop="up">
                <Dropdown.Toggle variant="success" id="post-list-dropdown">
                    <FontAwesomeIcon icon={['fas', 'circle']} />
                    <FontAwesomeIcon icon={['fas', 'circle']} />
                    <FontAwesomeIcon icon={['fas', 'circle']} />
                </Dropdown.Toggle>

                <Dropdown.Menu align="right">
                    <Dropdown.Item onClick={handleCopy}>
                        Copy link to post
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleEdit}>
                        Edit post
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleDeleteConfirm}>
                        Delete post
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handlePin}>
                        {
                            post.pinned ? 'Un-pin to your profile' : 'Pin to your profile'
                        }
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleWallAlbums}>
                        Add to wall albums
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    </>;
};

function mapStateToProps(state) {
    return {
        darkmode: state.privaGlobal.darkmode,
        activePost: state.privaGlobal.selectedPost,
        action: state.post.action,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        deletePost: (payload) => dispatch(deletePost(payload)),
        setShowPostAlbum: payload => dispatch(setShowPostAlbum(payload)),
        setSelectedPost: payload => dispatch(setSelectedPost(payload)),
        setCategoriesMode: payload => dispatch(setCategoriesMode(payload)),
        setPostAction: payload => dispatch(setPostAction(payload)),
        setDarkmode: (payload) => dispatch(setDarkmode(payload)),
        setAlert: (payload) => dispatch(setAlert(payload)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PostActions);
